import exploreListings from '@/components/search-result/explore-listings';
import { normalizeParams } from '@/components/search-result/_center-adaptor/normalizeParams';
import { searchRealTimeListings } from '../../common/search-request';
import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';
import util from '@/common/util';
export const NBR_TYPE_NUM = {
    0: 'city',
    1: 'subdivision',
    2: 'community',
    3: 'area'
};
export default {
    data: function() {
        return {
            featureArea: {},
            averageData: []
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            isSearchCenter: store => store.page.searchCenter,
            global: store => store.page || {}
        }),
        breadCrumbs({ featureArea }) {
            let crumbs = [
                {
                    name: featureArea.state,
                    keywordType: 'state',
                    key: featureArea.state
                },
                {
                    name: featureArea.city,
                    keywordType: 'city',
                    key: `${featureArea.city}, ${featureArea.state}`
                }
            ];
            if (featureArea.type === 'neighborhood') {
                crumbs.push({
                    name: featureArea.neighborhood,
                    keywordType: 'neighborhood',
                    key: `${featureArea.neighborhood}, ${featureArea.city}, ${featureArea.state}`
                });
            }
            return crumbs;
        },
        location({ featureArea }) {
            let keyword = '';
            const areas = ['neighborhood', 'city', 'state'];
            areas.forEach(key => {
                featureArea[key] && (keyword += `${featureArea[key]}, `);
            });
            keyword && (keyword = keyword.slice(0, keyword.length - 2));
            return [
                {
                    keyword,
                    keywordType: NBR_TYPE_NUM[featureArea.featureAreaType]
                }
            ];
        }
    },
    components: { exploreListings },
    methods: {
        getAverageData() {
            const params = normalizeParams(
                this.isSearchCenter,
                {
                    key: this.location[0].keyword,
                    keywordType: this.location[0].keywordType,
                    'listingStatus-multi-Back-on-Market': 'Active',
                    'purchaseType-For-Sale-Rent': '1'
                },
                {},
                { needKey: true }
            );
            params.avgTypes = [
                'AVG_PRICE',
                'AVG_BEDROOMS',
                'AVG_BATHS',
                'AVG_SQFT'
            ];
            params.cache = false;
            params.timezone = this.getCookie('timezone') || util.getTimeZone();
            searchRealTimeListings
                .call(this, {
                    params,
                    type: 'neighborAvg',
                    globalData: this.global
                })
                .then(ret => {
                    const { avgExcludeInvalidResults, counts } =
                        ret.data || ret;
                    const { avgResultList } = avgExcludeInvalidResults || {};
                    this.averageData = {
                        counts: counts || 0,
                        avgResultList: avgResultList || []
                    };
                });
        }
    },
    mounted() {
        this.getAverageData();
    }
};
